import { createContext, useContext } from 'react';
import { NavigationPaneContextProps } from './NavigationPane.types';

export const NavigationPaneContext = createContext<NavigationPaneContextProps<string> | undefined>(undefined);

export const useNavigationPaneContext = () => {
  const context = useContext(NavigationPaneContext);
  if (context === undefined) {
    throw new Error('useNavigationPaneContext must be used within a NavigationPaneProvider');
  }
  return context;
};
